module.exports = __webpack_public_path__ + "img/compang-logo-s.3108aa1f.png";